import _ from 'lodash'
import $ from 'jquery'
import Button from '../button'
import ResizeAware from '../resize-aware'
import isServer from '../../core/KServer'
// import KUuid from '../../core/utils/KUuid'
// import TabPane from './TabPane'

export default {
  name: 'KTabs',
  provide() {
    return {
      context: this,
    }
  },
  props: {
    value: {
      type: String,
      default: '',
    },
    borderless: {
      type: Boolean,
      default: false,
    },
    beforeClear: {
      type: Function,
    },
    // 隐藏指示器
    hideIndicator: {
      type: Boolean,
      default: false,
    },
    // 指示器颜色：primary, secondary, warning, danger, success
    indicatorColor: {
      type: String,
      default: 'primary',
    },
    // 指示器宽度px：默认为当前激活选项卡的宽度
    indicatorWidth: {
      type: Number,
      default: null,
    },
    // 激活编辑模式（每个TabNav上会显示删除按钮）
    editable: {
      type: Boolean,
      default: false,
    },
    // 居中显示
    center: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      panes: [],
      activePaneId: null, // pane name
      indicator: {
        left: 0,
        width: 0,
      },
      scrollX: 0,
      scrollWidth: 0,
      navsWidth: 0,
    }
  },
  computed: {
    shouldRenderNavControlButton() {
      //   const { navs, navScroll } = this.$refs
      //   if (!navs || !navScroll) {
      //     return
      //   }
      //
      //   const navsWidth = navs.getBoundingClientRect().width
      //   const scrollWidth = navScroll.getBoundingClientRect().width
      return this.navsWidth > this.scrollWidth
    },
  },
  watch: {
    value: {
      immediate: true,
      handler(id) {
        this.activePaneId = id
      },
    },
    activePaneId: {
      immediate: true,
      handler(id) {
        this.$emit('input', id)
        this.$nextTick(() => {
          this.scrollNavIntoView(id)
          this.updateIndicator(id)
        })
      },
    },
    panes(panes) {
      if (!panes.length) {
        return
      }
      const activatePane = _.find(panes, (pane) => pane.id === this.activePaneId)
      if (!activatePane) {
        this.$nextTick(() => {
          this.activePaneId = panes[0].id
        })
      }
    },
    shouldRenderNavControlButton(value) {
      if (!value) {
        this.$nextTick(() => {
          console.log('scrollX')
          this.scrollX = 0
        })
      }
    },
  },
  created() {},
  mounted() {
    this.$nextTick(() => {
      if (this.$slots.headerAffix && this.$slots.headerAffix[0] && this.$slots.headerAffix[0].componentInstance) {
        const affixInstance = this.$slots.headerAffix[0].componentInstance
        affixInstance.apiSetAffixElement(this.$refs.header)
      }
    })
  },
  methods: {
    calcNavSize() {
      const $navScroll = $(this.$refs.navScroll)
      const $navs = $(this.$refs.navs)
      this.scrollWidth = $navScroll.width()
      this.navsWidth = $navs.width()

      if (this.scrollWidth >= this.navsWidth) {
        this.scrollX = 0
      } else if (this.scrollX > this.navsWidth - this.scrollWidth) {
        this.scrollX = this.navsWidth - this.scrollWidth
      }
    },
    scrollPrev() {
      // this.calcNavSize()
      const containerWidth = this.scrollWidth

      const leftWidth = Math.abs(this.scrollX)
      if (leftWidth > containerWidth) {
        this.scrollX = leftWidth - containerWidth
      } else {
        this.scrollX = 0
      }
    },
    scrollNext() {
      // this.calcNavSize()
      const containerWidth = this.scrollWidth
      const navsWidth = this.navsWidth

      const rightWidth = navsWidth - this.scrollX - containerWidth
      if (rightWidth > containerWidth) {
        this.scrollX = this.scrollX + containerWidth
      } else {
        this.scrollX = navsWidth - containerWidth
      }
    },
    scrollNavIntoView(id) {
      if (isServer) {
        return
      }
      const $nav = $(this.$refs['tabNav' + (id || this.activePaneId)])
      if (!$nav.length) {
        this.scrollX = 0
        return
      }

      this.calcNavSize()
      const containerWidth = this.scrollWidth
      const navLeft = $nav.position().left
      const navWidth = $nav.outerWidth()
      const scrollX = Math.abs(this.scrollX)

      // const isInView = navLeft + navWidth <= containerWidth + scrollX && navLeft >= scrollX
      // 部分在外也算
      const isOnViewRight = navLeft + navWidth > containerWidth + scrollX
      const isOnViewLeft = navLeft < scrollX
      if (!isOnViewRight && !isOnViewLeft) {
        return
      }

      if (isOnViewRight) {
        this.scrollX = navLeft - containerWidth + navWidth
      } else {
        this.scrollX = navLeft
      }
    },
    // shouldRenderNavControlButton() {
    //   const { navs, navScroll } = this.$refs
    //   if (!navs || !navScroll) {
    //     return
    //   }
    //
    //   const navsWidth = navs.getBoundingClientRect().width
    //   const scrollWidth = navScroll.getBoundingClientRect().width
    //   return navsWidth > scrollWidth
    // },
    renderNavControl(next = false) {
      const css = {
        'km-tab__nav-control': true,
        'km-tab__nav-control--next': next,
      }

      const props = {
        icon: next ? 'angle-right' : 'angle-left',
        type: 'gray',
        plain: true,
        hoverMode: {
          type: 'primary',
        },
      }

      const events = {
        click: next ? this.scrollNext : this.scrollPrev,
      }

      const data = {
        class: css,
        props,
        on: events,
      }

      return (
        <Button
          {...data}
        >
        </Button>
      )
    },
    renderNavs() {
      const showIndicator = !this.hideIndicator && this.activePaneId
      const indicatorCss = {
        'km-tab__indicator': true,
      }

      const indicatorStyle = {
        left: this.indicator.left,
        width: this.indicator.width,
      }

      if (this.indicatorColor) {
        if (['primary', 'secondary', 'warning', 'success', 'danger'].indexOf(this.indicatorColor) !== -1) {
          indicatorCss[`km-tab__indicator--${this.indicatorColor}`] = true
        } else {
          indicatorStyle.backgroundColor = this.indicatorColor
        }
      }

      return (
        <div
          ref="navScroll"
          class={{
            'km-tab__nav-scroll': true,
            'is-justify-center': this.center,
          }}
        >
          <ResizeAware
            onResize={() => {
              this.scrollNavIntoView()
            }}
          />
          <div
            ref="navs"
            class="km-tab__navs"
            style={{
              transform: `translateX(-${this.scrollX}px)`,
            }}
          >
            {
              _.map(this.panes, (pane) => {
                return this.renderTab(pane)
              })
            }
            <transition name="km-bounce-in">
              {showIndicator ? (
                <div
                  class={indicatorCss}
                  style={indicatorStyle}
                />
              ) : null}
            </transition>
          </div>
        </div>
      )
    },
    renderTabNav() {
      const css = {
        'km-tab__nav-wrapper': true,
      }

      const data = {
        class: css,
      }

      if (!this.$slots.header) {
        data.ref = 'header'
      }

      let navControlPrev = null
      let navControlNext = null
      const shouldRenderControl = this.shouldRenderNavControlButton
      if (shouldRenderControl) {
        navControlPrev = this.renderNavControl()
        navControlNext = this.renderNavControl(true)
      }

      const content = [
        this.$slots.header ? null : this.$slots.headerAffix,
        navControlPrev,
        this.renderNavs(),
        navControlNext,
        this.$slots.extra
          ? (
            <div class="km-tab__extra">
              {this.$slots.extra}
            </div>)
          : null,
      ]

      return (
        <div {...data}>
          {content}
        </div>
      )
    },
    renderTab(pane) {
      const css = {
        'km-tab__nav': true,
        'km-tab__nav--active': this.activePaneId === pane.id,
      }

      const attrs = {}

      const events = {
        click: () => {
          this.activatePane(pane)
        },
      }

      const data = {
        class: css,
        attrs,
        on: events,
      }

      const showCloseButton = this.editable && pane.closable && this.panes.length > 1

      const tab = pane.$slots.tab || pane.tab
      return (
        <a {...data}>
          <div
            ref={'tabNav' + pane.id}
            class="km-tab__nav-inner"
          >
            {tab}
            {
              showCloseButton
                ? <Button
                  type="grey"
                  size="mini"
                  class="km-tab__close"
                  plain={true}
                  circle={true}
                  icon="times"
                  onClick={(e) => {
                    e.stopPropagation()
                    this.$emit('tabClose', pane.id)
                  }}
                /> : null
            }
          </div>
        </a>
      )
    },
    renderTabContent() {
      const css = {
        'km-tab__content': true,
      }

      const data = {
        class: css,
      }

      return <div {...data}>{this.$slots.default}</div>
    },
    activatePane(pane) {
      this.activePaneId = pane.id
    },
    updateIndicator(id) {
      if (isServer) {
        return
      }
      id = id || this.activePaneId

      if (!id) {
        return
      }

      const $nav = $(this.$refs['tabNav' + id])
      if (!$nav.length) {
        return
      }

      const gutter = 4

      let width = $nav.outerWidth() + gutter * 2
      let left = $nav.position().left - gutter

      if (+this.indicatorWidth > 0) {
        left = left + (width - this.indicatorWidth) / 2
        width = this.indicatorWidth
      }

      this.$nextTick(() => {
        this.indicator = {
          left: left + 'px',
          width: width + 'px',
        }
      })
    },
    updatePane(pane) {
      const has = _.findIndex(this.panes, ['id', pane.id]) !== -1
      if (!has) {
        this.panes.push(pane)
      }
      this.scrollNavIntoView()
      this.updateIndicator()
    },
    removePanel(pane) {
      const paneIndex = this.panes.indexOf(pane)
      if (paneIndex !== -1) {
        this.panes.splice(paneIndex, 1)
      }
      this.scrollNavIntoView()
      this.updateIndicator()
    },
    focus() {
      this.$el.focus()
    },
  },
  render() {
    const style = {}
    if (this.color) {
      style.color = this.color
    }

    const css = {
      'km-tab': true,
    }

    const attrs = {
      disabled: this.disabled,
    }

    if (!this.disabled) {
      attrs.tabindex = -1
    }

    const events = {}

    const data = {
      style: style,
      class: css,
      attrs: attrs,
      events: events,
    }

    const nav = this.renderTabNav()
    const content = this.renderTabContent()

    return (
      <div {...data}>
        {
          this.$slots.header ? (
            <div
              ref="header"
              class="km-tab__header"
            >
              <div class="km-tab__header-inner">
                {this.$slots.header}
              </div>
              {nav}
              {this.$slots.headerAffix}
            </div>) : nav
        }
        {content}
      </div>
    )
  },
}
